import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const getParentServices = async (companies) => {
  const res = await request.get(
    '/Request/parent_services',
    companies?.length > 0 ? { companies } : {},
    'При загрузке услуг произошла ошибка',
    [],
    undefined,
    'comma'
  );

  return res;
};

const useParentServices = ({ companies, options }) =>
  useQuery(
    [
      'parentServices',
      Array.isArray(companies) ? [...companies].sort() : companies,
    ],
    () => getParentServices(companies),
    {
      ...options,
    }
  );

export default useParentServices;
